define.alias("ember-cli-string-helpers/utils/titleize", "preview-grid/utils/titleize");